import { render, staticRenderFns } from "./IconLivePresent.vue?vue&type=template&id=32a1ef54"
import script from "./IconLivePresent.vue?vue&type=script&lang=ts"
export * from "./IconLivePresent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports